/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getSelectedText__anchor
 */
export default () => window.documentViewer.getSelectedText();
